export default __webpack_public_path__ + "navigation-guide-device-notification-1200-f707e5651841c7481d31f1035dff2f4e.webp";